export default __webpack_public_path__ + "static/camp-entry-ebc28000ca88c0cf3746fbe916f6eebc.jpeg";